import { BullhornEntityType } from './bullhorn/bullhorn-entity-type';

// ToDo update optional properties when refactoring the old card out of this project
export interface IPromptProfile {
  corpId?: string;
  action: string | undefined;
  role?: any;
  removeBias?: boolean;
  format?: any;
  tone?: any;
  explanationDifficulty?: any;
  resultLength?: any;
  outputLanguage?: any;
  outputFieldName?: string | undefined;
  entityType: BullhornEntityType | undefined;
  anonymise?: boolean;
  showContext?: boolean;
  additionalContext?: string | null;
  promptId?: string | null;
  canCustomize?: boolean;
  enabled?: boolean;
  displayName?: string;
  sourceFields?: any;
  LLMs?: any;
  description?: string;
  promptType?: PromptType;
  integration?: string | undefined;
  noteFilter?: any;
  fileFilter?: any;
  fileConfig?: {
    fileName: string;
    fileType: string;
    enabled: boolean;
  };
  allowedUserTypes?: string[];
  allowedDepartments?: string[];
  allowedPrivateLabels?: string[];
  enableCopyButton?: boolean;
  enableSaveAsNote?: boolean;
}

export interface IFilter {
  isNotesEnabled?: boolean;
  isFilterEnabled?: boolean;
  date?: IDateFilter;
  count?: number;
  sort?: string;
  autoInclude?: boolean;
  // For file filter category will equal type, for note filter it would equal action
  category?: string[];
}

export interface IDateFilter {
  rangeType: DateFilterType;
  timeAmount?: number;
  startDate?: number;
}

export interface IEntityTypeCount {
  entityType: BullhornEntityType;
  count: number;
}

export enum FilterLabel {
  FILE = 'File',
  NOTE = 'Note'
}
export enum DateFilterType {
  LATEST = 'latest'
}
export enum SortFilterType {
  OLDEST = 'dateAdded',
  NEWEST = '-dateAdded',
}

export enum PromptType {
  AI_ADDON_PROMPT = 'AI_ADDON_PROMPT',
  STANDARD = 'STANDARD'
}
